<template>
  <div class="home">
    <!-- <BrowserInfo v-show="showBrowserTip" @showTip="showTip" @ignore="ignore" /> -->
    <Layout class="home-all">
      <div class="header">
        <div class="header-left">
          <div class="switch" v-show="navStatus != 0" @click="collapsedSider()">
            <Icon type="ios-menu-outline" />
          </div>
          <img
            class="fontcursor"
            @click="linkOverview('/overview')"
            style="margin-left: 24px; margin-right: -10px"
            src="../../assets/img/login/logo copy.png"
          />
          <span class="ml-16 fontcursor" @click="linkOverview('/overview')"
            >平台管理中心</span
          >
        </div>
        <div class="header-right">
          <div class="flexfs itemMenu" v-if="rightStatus != 0">
            <div class="phoneCard" v-if="phoneFlag == true">
              <div class="topImg icon tsit icon_paixu"></div>
              <div class="phoneImg">
                <img src="~@/assets/img/phone.png" alt />
              </div>
              <div>
                <p class="hour">24小时咨询热线</p>
                <p class="phoneNum">400-666-8888 转 1</p>
              </div>
            </div>
          </div>
          <headRight :status="rightStatus" />
        </div>
      </div>
      <Layout class="main" v-if="navStatus != 0">
        <Sider
          ref="side"
          v-model="isCollapsed"
          hide-trigger
          collapsible
          :style="isCollapsed ? closeMenu : openMenu"
        >
          <Menu
            :active-name="activeName"
            theme="light"
            width="auto"
            :class="menuitemClasses"
            @on-select="link"
          >
            <MenuItem
              :class="isCollapsed ? 'little-item' : ''"
              v-for="(item, index) in sideMenuList"
              :key="index"
              :name="item.path"
            >
              <Tooltip
                v-if="isCollapsed"
                :content="item.displayName"
                placement="right"
                class="menuTip"
              >
                <i :class="`icon tsit ${item.icon}`"></i>
              </Tooltip>
              <i v-else :class="`icon tsit ${item.icon}`"></i>
              <span class="ml-8">{{ item.displayName }}</span>
            </MenuItem>
          </Menu>
        </Sider>
        <!-- viewpad 有二级时无padding-->
        <Layout :class="navStatus == 1 ? '' : 'viewpad'">
          <div class="main-top">
            <Breadcrumb v-show="navStatus == 2" :style="{ margin: '24px 0px' }">
              <BreadcrumbItem v-for="(item, index) in bread" :key="item.path">
                <span v-if="index == bread.length - 1">
                  {{ item.meta.title }}
                </span>
                <router-link v-else :to="item.redirect || item.path">
                  {{ item.meta.title }}
                </router-link>
              </BreadcrumbItem>
            </Breadcrumb>
            <div class="help fontcursor" v-if="path == '/overview'">
              <p class="query">?</p>
              <p class="txt">帮助文档</p>
            </div>
          </div>
          <!-- home-body100 有二级菜单时 -->
          <Content :class="navStatus == 1 ? 'home-body100' : 'home-body'">
            <router-view></router-view>
          </Content>
        </Layout>
      </Layout>
      <!-- 服务商城，帮助文档 -->
      <div class="centermain" v-if="navStatus == 0">
        <div class="centermain-body">
          <router-view></router-view>
        </div>
      </div>
    </Layout>
    <!-- 代替menuitem触发点击事件 -->
    <div v-show="false" ref="substitute" @click="abcd = 10"></div>
  </div>
</template>

<script>
import headMenu from "./components/head-menu.vue";
import headRight from "./components/head-right.vue";
import { getUserInfo } from "@/api/user";
export default {
  name: "Home",
  components: {
    headMenu,
    headRight,
  },
  watch: {
    $route() {
      // console.log(this.$route, "当前路由");
      this.path = this.$route.path;
      //免登录页面，导航栏右侧为未注册状态
      this.topStatus();
      this.topSelect();
      //编辑时修改面包屑
      this.breadEdit();
    },
  },
  computed: {
    // showBrowserTip() {
    //   // console.log(this.$store.state.showBrowserTip,"this.$store.state.showBrowserTip--");
    //   return this.$store.state.showBrowserTip;
    // },
    /**
     * 0：无菜单，无面包屑
     * 1：有菜单，无面包屑
     * 2：有菜单，有面包屑
     */
    navStatus() {
      return this.$route.meta.navtype;
    },
    /** 选中的菜单*/
    // activeName() {
    //   let self = this;
    //   let activeName = self.$route.path;
    //   console.log(self.$route.meta.active, activeName, "---activename--");
    //   return self.$route.meta.active || activeName;
    // },
    activeName() {
      let self = this;
      let activeName;
      let activeList = self.$route.meta.active;
      console.log(activeList, "activeList---");
      if (activeList instanceof Array && activeList.length) {
        //遍历菜单列表，拿到路由的active ,如果含有返回
        let menuList = this.$store.state.menuList;
        menuList.forEach((item) => {
          let t = activeList.find((x) => x == item.path);
          if (t) {
            activeName = t;
          }
        });
        return activeName;
      } else {
        return activeList;
      }
    },
    //一级菜单展开
    activeMenu() {
      let self = this;
      let activeList = [];
      activeList.push(self.$route.meta.active_menu);
      return activeList;
    },
    bread() {
      let matched = this.$route.matched.filter((item) => item.name);
      matched = matched.filter((x) => x.meta.title);
      return matched;
    },
    menuitemClasses() {
      //是否折叠
      // return []
      // "menu-item",
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
    sideMenuList() {
      return this.$store.state.menuList;
    },
  },
  data() {
    return {
      //导航栏右部状态:注册(0)，未认证(1)，已认证(2)
      rightStatus: 1,
      phoneFlag: false,
      isCollapsed: false,
      path: "",
      topMenuActive: 0,
      openMenu: {
        width: "240px",
        minWidth: "240px",
        maxWidth: "240px",
        flex: "0 0 240px",
        background: "#fff",
      },
      closeMenu: {
        width: "64px",
        minWidth: "64px",
        maxWidth: "64px",
        flex: "0 0 64px",
        background: "#fff",
      },
      //免登录白名单
      whiteList: ["/register", "/resetpwd"],
      //面包屑新建或者修改
      addOrEditList: [
        "/setting/roleindex/rolepage",
        "/setting/userindex/userpage",
      ],
    };
  },

  created() {
    let route = this.$route;
    this.topSelect();
    //免登录页面，导航栏右侧为未注册状态
    this.topStatus();
    //编辑时修改面包屑
    this.breadEdit();
    this.path = this.$route.path;
    this.getUserInfo();
  },
  methods: {
    // showTip(flag) {
    //   if (localStorage.AGENT_TIP && JSON.parse(localStorage.AGENT_TIP) == false) { return }
    //   this.$store.commit("setBrowserTip", flag);
    // },
    // ignore() {
    //   this.$store.commit("setBrowserTip", false);
    // },
    getUserInfo() {
      getUserInfo().then((res) => {
        this.$store.commit("setUserImg", res.data.data.avatarUrl);
      });
    },
    //面包屑修改
    breadEdit() {
      let route = this.$route;
      let path = this.$route.path;
      if (this.addOrEditList.indexOf(path) != -1) {
        if (route.query.type == "edit") {
          let str = route.meta.title;
          let substr = str.substring(2);
          route.meta.title = "编辑" + substr;
        } else {
          let str = route.meta.title;
          let substr = str.substring(2);
          route.meta.title = "新建" + substr;
        }
      }
    },
    //头部菜单选中项
    topSelect() {
      let matched = this.$route.matched;
      //topMenuActive 头部菜单选中项
      if (matched[0].name == "service") {
        //服务商城模块
        this.topMenuActive = 1;
      } else if (matched[0].name == "order") {
        //工单模块
        this.topMenuActive = 3;
      } else {
        //控制台
        this.topMenuActive = 4;
      }
    },
    //头部右侧是否显示菜
    topStatus() {
      let path = this.$route.path;
      //免登录页面，导航栏右侧为未注册状态
      if (this.whiteList.indexOf(path) !== -1) {
        this.rightStatus = 0;
      } else {
        this.rightStatus = 1;
      }
    },
    showPhone(item) {
      if (item.id == 2) {
        this.phoneFlag = true;
      }
    },
    hidePhone(item) {
      if (item.id == 2) {
        this.phoneFlag = false;
      }
      let matched = this.$route.matched;
      //隐藏时，选中当前路由下的菜单
      if (matched[0].name == "service") {
        //服务商城模块
        this.topMenuActive = 1;
      } else if (matched[0].name == "order") {
        //工单模块
        this.topMenuActive = 3;
      } else {
        //控制台
        this.topMenuActive = 4;
      }
    },
    selectMenu(item) {
      this.topMenuActive = item.id;
    },
    hoverMenu(item) {
      if (item.id == 2) {
        this.topMenuActive = item.id;
      }
    },
    collapsedSider() {
      //折叠切换
      this.$refs.side.toggleCollapse();
    },
    link(path) {
      console.log(path, "跳转登录也");
      // return
      this.$refs.substitute.click(); // 代替menuitem触发click事件，让dorpdown关闭
      this.$router.push({ path: path });
      console.log("点击左侧菜单跳转", path);
    },
    linkOverview(path) {
      if (localStorage.IS_ACCESS_INDUSTRY === "1") {
        return;
      }
      this.$router.push({ path: path });
    },
    loginout() {
      let self = this;
      self.link("login");
    },
  },
};
</script>
<style lang="scss">
.home {
  width: 100%;
  height: 100vh;
  // border: 1px red solid;
  &-all {
    width: 100%;
    height: 100%;
    .header {
      width: 100%;
      height: 64px;
      background: #fff;
      border-bottom: 1px #ebedf0 solid;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      font-family: MicrosoftYaHeiSemibold;
      color: #2f4061;
      font-weight: 500;
      &-left {
        display: flex;
        align-items: center;
        .switch {
          width: 64px;
          height: 64px;
          background: #3c8aff;
          text-align: center;
          line-height: 64px;
          font-size: 30px;
          color: #fff;
        }
      }
      &-right {
        height: 100%;
        display: flex;
        align-items: center;
        padding-right: 24px;
        font-size: 16px;
        .itemMenu {
          position: relative;
          .phoneCard {
            width: 220px;
            height: 80px;
            background: #ffffff;
            box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
            border: 1px solid #ebeef5;
            position: absolute;
            right: 100px;
            top: 50px;
            box-sizing: border-box;
            padding: 20px;
            display: flex;
            z-index: 1000;
            .topImg {
              position: relative;
              top: -33px;
              left: 165px;
              color: #fff;
              font-size: 20px;
              margin-left: -20px;
            }
            .phoneImg img {
              width: 28px;
              height: 28px;
              margin-right: 15px;
            }
            .hour {
              font-size: 16px;
              color: #2f4061;
              font-weight: bold;
            }
            .phoneNum {
              font-size: 14px;
              color: #2f4061;
            }
          }
        }
      }
    }
  }
  .main {
    width: 100%;
    height: calc(100% - 64px);
    .ivu-menu-vertical .ivu-menu-item,
    .ivu-menu-vertical .ivu-menu-submenu-title {
      padding: 20px 24px;
    }
    &-top {
      display: flex;
      justify-content: space-between;
      .help {
        height: 100%;
        display: flex;
        align-items: center;
        .query {
          width: 16px;
          height: 16px;
          background: #fff;
          border: 1px solid #919caf;
          color: #919caf;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          margin-right: 10px;
        }
        .txt {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #919caf;
          margin-right: 10px;
        }
      }
    }
    .little-item {
      padding: 20px 12px !important;
    }
    .menuTip {
      .ivu-tooltip-popper {
        left: 62px !important;
      }
    }
    .menu-item {
      min-height: calc(100vh - 64px) !important;
    }
    .menu-item span {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: bottom;
      width: 100px;
      transition: width 0.2s ease 0.2s;
      line-height: 24px;
      margin-left: 8px;
    }
    .menu-item i {
      transform: translateX(0px);
      transition: font-size 0.2s ease, transform 0.2s ease;
      vertical-align: middle;
      font-size: 16px;
      line-height: 24px;
    }
    .collapsed-menu span {
      width: 0px;
      margin-left: 0px;
      transition: width 0.1s ease;
    }
    .collapsed-menu i {
      transform: translateX(5px);
      transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
      vertical-align: middle;
      font-size: 18px;
      margin-left: 8px;
    }
  }
  &-body {
    width: 100%;
    height: calc(100% - 69px);
    overflow: auto;
  }
  &-body100 {
    width: 100%;
    height: 100%;
  }
  .viewpad {
    padding: 0 24px 24px;
  }
  .centermain {
    width: 100%;
    height: calc(100% - 64px);
    overflow: auto;
    padding: 0 32px 32px 32px;
    &-body {
      width: 100%;
      // height: 100%;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
